import type { UserStories } from '../types';

/** A story is considered unseen until the API explicitly confirms it was viewed. */
export const hasUnseenStories = (userStories: UserStories): boolean =>
  userStories.stories.some(story => story.has_viewed !== true);

/** Keeps the signed-in user's stories first, then shows unseen users first. */
export const orderUserStoriesByUnseen = (
  userStories: UserStories[],
  currentUserId?: number,
): UserStories[] =>
  [...userStories].sort((left, right) => {
    const ownOrder =
      Number(right.user.id === currentUserId) - Number(left.user.id === currentUserId);

    return ownOrder || Number(hasUnseenStories(right)) - Number(hasUnseenStories(left));
  });

/** Updates only the story that was opened, preserving viewer navigation order. */
export const markStoryAsViewed = (
  userStories: UserStories[],
  storyId: number,
): UserStories[] =>
  userStories.map(item => ({
    ...item,
    stories: item.stories.map(story =>
      story.id === storyId ? { ...story, has_viewed: true } : story,
    ),
  }));
